import React from 'react';
import landing from './Styles/LandingPage.module.css'
import {Link} from "react-router-dom";
import TopMenu from "./Components/TopMenu";

const LandingPage = () => {
    return (
        <div className={landing.landing}>
           <TopMenu isActiveHome={true} />

            <div className={landing.label}>
                Absolutely Free Node-based dialogue tree creator.
            </div>
            <Link
                className={landing.tryitbutton}


                to={{pathname:"/app"}}>Try It
            </Link>

        </div>
    );
};

export default LandingPage;